import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useSessionStore } from '@entities/session';
import { ROUTES } from '@shared/config/routes';
import { logout } from '../api/logout';

export function useLogout() {
  const navigate = useNavigate();
  const clear = useSessionStore((s) => s.clear);
  const qc = useQueryClient();

  return useMutation({
    mutationFn: () => logout(),
    onSettled: () => {
      clear();
      qc.clear();
      navigate(ROUTES.login, { replace: true });
    },
  });
}
